import { atom } from "recoil";
import { BlockVisibility, BlockVisibilityType } from "../../types/block/enum";
import { localStorageEffect } from "../localStorage/localStorageEffect";

export const visibilityState = atom<BlockVisibilityType>({
  key: "visibilityState",
  default: BlockVisibility.PUBLIC,
  effects: [localStorageEffect("visibility", BlockVisibility.PUBLIC as BlockVisibilityType)],
});
